import React from "react";

/**
 * Render a category icon — chooses the best visual based on what the
 * caller has indicated:
 *
 *   - `variant="button"` → uses the 3D steel-frame neon button artwork
 *     (`cat.buttonSrc`) when available. This is the canonical look used
 *     by the main vault grid tile, the category sub-page header, the
 *     empty-state hero, and the per-entry card icon, so the steel
 *     aesthetic stays consistent throughout every level of the vault.
 *   - default → falls back to the hand-painted flat PNG (`cat.iconSrc`)
 *     and finally to the Phosphor SVG. Use this when the small-form-
 *     factor flat icon reads better than the detailed 3D button (e.g.
 *     non-vault chrome like settings rows).
 */
export default function CatIcon({ cat, size = 22, color, variant }) {
  if (variant === "button" && cat?.buttonSrc) {
    return (
      <img
        src={cat.buttonSrc}
        alt=""
        aria-hidden
        draggable={false}
        style={{ width: size, height: size, objectFit: "contain" }}
      />
    );
  }
  if (cat?.iconSrc) {
    return (
      <img
        src={cat.iconSrc}
        alt=""
        aria-hidden
        style={{ width: size, height: size, objectFit: "contain" }}
      />
    );
  }
  const I = cat?.Icon;
  if (!I) return null;
  return <I size={size} weight="duotone" color={color || cat?.color} />;
}
